import {Service} from '@s-ui/domain'

export class GetIdentifyTrackingDataService extends Service {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Object} deps.config
   * @param {Service} deps.getCurrentUserService
   * @param {Mapper} deps.identifyMapper
   * @param {Repository} deps.repository
   */
  constructor({config, getCurrentUserService, identifyMapper, repository}) {
    super()

    this._config = config
    this._getCurrentUserService = getCurrentUserService
    this._identifyMapper = identifyMapper
    this._repository = repository
  }

  /**
   * @method
   * @private
   * @param {Object} params
   * @param {String} params.event
   * @param {Object} params.user
   * @return {Boolean} Returns if tracking event needs to identify the user or
   * even if user has to be identified in the first visit (regardless the event).
   */
  async _needsIdentify({event, user}) {
    if (!user) return false

    const {TRACKING_EVENTS_THAT_NEED_IDENTIFY} = this._config.get('tracking')
    const {userId} = user
    // Check if user is already identified.
    const isUserIdentified = await this._repository.checkIfUserIsIdentified({
      userId
    })
    // If not, indentify it now.
    !isUserIdentified && (await this._repository.identifyUser({userId}))

    return (event && TRACKING_EVENTS_THAT_NEED_IDENTIFY.includes(event)) || !isUserIdentified
  }

  /**
   * @param {Object} params
   * @param {String} params.event
   * @return {Promise<Object, Error>} This is a Promise return value.
   */
  async execute({event}) {
    const userEntity = await this._getCurrentUserService.execute()
    const user = userEntity?.toJSON?.()

    if (!event) return

    const needsIdentify = await this._needsIdentify({
      event,
      user
    })

    const identify = needsIdentify ? this._identifyMapper.map({user}) : null

    return identify
  }
}
